import './IconFavoriteFilled.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconFavoriteFilled = function IconFavoriteFilled(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 18 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 18",
    className: className
  }, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    x: "0px",
    y: "0px",
    width: "17.997px",
    height: "16px",
    viewBox: "6.002 4 17.997 16",
    enableBackground: "new 6.002 4 17.997 16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0090D7",
    d: "M13.376,6.9l9.118-1.42c-2.023-1.973-5.251-1.973-7.274,0L15,5.7l-0.22-0.22\r c-2.022-1.973-5.25-1.973-7.273,0c-1.975,1.93-2.011,5.096-0.081,7.071c0.027,0.027,0.054,0.054,0.081,0.081L15,20l7.494-7.368\r c1.975-1.93,2.012-5.096,0.081-7.07c-0.026-0.027-0.054-0.055-0.081-0.082"
  }))));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s5ennsy"
});
export default IconFavoriteFilled;